import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';
import { CodebookModel } from 'app/shared/model/shared.model';
import { applicantPartyTypes } from 'app/shared/enumeration/enums';

export interface CaseApplicantModel {
  idApplicant?: number;
  partyType?: CodebookModel[];
  person: PersonModel;
  legalEntity: LegalEntityModel;
  email?: string;
  phoneNumber?: string;
  telephoneNumber?: string;
  applicantAddress: AddressModel;
  applicants: CodebookModel[];
  procurationType: CodebookModel[];
  procurationStatus: boolean;
  subjectType: CodebookModel[];
  oibFetched: boolean;
  earhiva: boolean;
  systemRecorded: boolean;
}

export interface ApplicantView {
  idApplicant: number;
  name: string;
  oibMb: string;
  partyType: string;
  address: string;
  email: string;
  systemRecorded: boolean;
  hasAssigneeLinkedOnlyToThisApplicant: boolean;
}

export const caseApplicantInitialData = {
  partyType: [applicantPartyTypes[0]],
  email: '',
  telephoneNumber: '+385',
  subjectType: [],
  person: {
    oib: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    address: null,
    subjectType: null,
  },
  legalEntity: {
    oib: '',
    mb: '',
    address: null,
    companyName: '',
    subjectType: null,
  },
  applicantAddress: initialAddress,
  applicants: [],
  procurationType: [],
  procurationStatus: true,
  oibFetched: true,
  earhiva: false,
  systemRecorded: false
};
